import filesize from 'filesize'

export const IMAGE_LIMIT_SIZE = 2097152
export const CREATE_TICKET_ERROR_MESSAGE =
  'There was a problem creating your ticket. If you continue to encounter this error, you can also submit your ticket in our Product Support Portal at https://support.airship.com.'

export const UPLOAD_IMAGE_SIZE_ERROR_MESSAGE = `Your upload exceeds the maximum file size of ${filesize(
  IMAGE_LIMIT_SIZE
)}.`

export const PRODUCTS_WITH_ADDITIONAL_FIELDS = [
  'web',
  'api',
  'ios',
  'android',
  'push_notification',
  'sdk',
]

export const AIRSHIP_SUPPORT_INSTANCE = 'https://support.airship.com/'
export const AIRSHIP_EU_SUPPORT_INSTANCE = 'https://support.airship.eu/'
